export class CFeaturedContent {
    constructor() {
        this.id = '';
        this.title = '';
        this.created = 0;
        this.modified = 0;
        this.priority = 0;
        this.type = '';
        this.client = [''];
        this.slug = '';
        this.status = '';
        this.image = '';
        this.content = '';
        this.region = '';
        this.language = '';
        this.tags = [''];
        this.exclude = [''];
        this.contentType = '';
        this.cta = '';
        this.startDate = 0;
        this.endDate = 0;
        this._rid = '';
        this._self = '';
        this._etag = '';
        this._attachments = '';
        this._ts = 0;
    }
}
//# sourceMappingURL=featuredContent.js.map